// @charset "utf-8";
const levelType = function (type) {
    switch (Number(type)) {
    case 1:
        return 'level1'
    case 2:
        return 'level2'
    case 3:
        return 'level3'
    case 4:
        return 'level4'
    default:
        return '--'
    }
}

const safeNumber = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num)
}

const safeIntegerNumber = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num).toFixed(0)
}

const safeFloatFixedOne = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num).toFixed(1)
}

const safeFloatFixedTwo = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num).toFixed(2)
}

const safeFloatPerFixedTwo = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num).toFixed(2) + '%'
}

const safePercentFixedTwo = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num * 100).toFixed(2) + '%'
}

const riseAndFallClass = function (num, standard) {
    if (isNaN(num)) {
        return ''
    }
    if (!standard) {
        standard = 0
    }
    return Number(num) > standard ? 'rise-red' : (Number(num) < standard ? 'fall-green' : '')
}

const eventNumberFixed = function (num) {
    if (Number(num) === -1) {
        return '--'
    } else if (Number(num) > -10 && Number(num) < 10) {
        return isNaN(num) ? '--' : Number(num * 100).toFixed(2) + '%'
    } else {
        return num
    }
}

const eventFallClass = function (num, standard) {
    if (Number(num) === -1) {
        return ''
    } else if (Number(num) > -10 && Number(num) < 10) {
        if (isNaN(num)) {
            return ''
        }
        if (!standard) {
            standard = 0
        }
        return Number(num) > standard ? 'rise-red' : (Number(num) < standard ? 'fall-green' : '')
    } else {
        return ''
    }
}

const strategyType = function (type) {
    if (Number(type) === 1) {
        return 'MindGo'
    } else if (Number(type) === 2) {
        return 'Backtest'
    } else if (Number(type) === 3) {
        return '果仁'
    } else {
        return '类型错误'
    }
}

const strategyStatus = function (status, key) {
    status = Number(status)
    switch (key) {
    case 0:
        if (status === 0) {
            return '保存未开始'
        } else if (status === 1) {
            return '保存中'
        } else if (status === 2) {
            return '保存失败'
        } else {
            return '保存成功'
        }

    case 1:
        if (status === 0) {
            return '回测未开始'
        } else if (status === 1) {
            return '回测中'
        } else if (status === 2) {
            return '回测失败'
        } else {
            return '回测成功'
        }

    case 2:
        if (status === 0) {
            return '数据准备'
        } else if (status === 1) {
            return '数据准备中'
        } else if (status === 2) {
            return '准备失败'
        } else {
            return '数据准备'
        }

    case 3:
        if (status === 0) {
            return '指标计算'
        } else if (status === 1) {
            return '指标计算中'
        } else if (status === 2) {
            return '计算失败'
        } else {
            return '指标计算'
        }

    case 4:
        if (status === 0) {
            return '分类标签'
        } else if (status === 1) {
            return '打标签中'
        } else if (status === 2) {
            return '分类失败'
        } else {
            return '分类标签'
        }

    case 5:
        if (status === 0) {
            return '门槛审核'
        } else if (status === 1) {
            return '门槛审核中'
        } else if (status === 2) {
            return '审核失败'
        } else if (status === 3) {
            return '审核成功'
        } else if (status === 4) {
            return '门槛审核不通过'
        } else {
            return '门槛审核通过'
        }

    case 6:
        if (status === 0) {
            return '人工审核'
        } else if (status === 1) {
            return '仿真中'
        } else if (status === 2) {
            return '上架失败'
        } else if (status === 3) {
            return '审核成功'
        } else if (status === 4) {
            return '人工审核不通过'
        } else if (status === 5) {
            return '已上架'
        } else if (status === 6) {
            return '下架中'
        } else {
            return '已下架'
        }
    }
}

const strategyStatusExt = function (status, key) {
    status = Number(status)
    switch (key) {
    case 0:
        if (status === 0) {
            return '新回测'
        } else if (status === 1) {
            return '新回测中'
        } else if (status === 2) {
            return '新回测失败'
        } else {
            return '新回测'
        }

    case 1:
        if (status === 0) {
            return '旧资产删除'
        } else if (status === 1) {
            return '删除中'
        } else if (status === 2) {
            return '删除失败'
        } else {
            return '旧资产删除'
        }

    case 2:
        if (status === 0) {
            return '数据重准备'
        } else if (status === 1) {
            return '重准备中'
        } else if (status === 2) {
            return '重准备失败'
        } else {
            return '数据重准备'
        }

    case 3:
        if (status === 0) {
            return '指标重计算'
        } else if (status === 1) {
            return '重计算中'
        } else if (status === 2) {
            return '重计算失败'
        } else {
            return '指标重计算'
        }
    default:
        return '--'
    }
}

const strategyStatusClass = function (status) {
    status = Number(status)
    if (status === 1 || status === 6) {
        return 'orange'
    } else if (status === 2 || status === 4 || status === 7) {
        return 'error'
    } else if (status === 3 || status === 5) {
        return 'green'
    } else {
        return ''
    }
}

const changeDateVal = function (date) {
    if (date === undefined) {
        return '--'
    }
    return String(date).substring(0, 4) + '-' + String(date).substring(4, 6) + '-' + String(date).substring(6)
}

const slicetwo = function (data) {
    return String(data).substring(0, 6)
}

const labelField = (field) => {
    field = parseInt(field)
    if (field === 0) {
        return '平均持有天数'
    } else if (field === 1) {
        return '成长性'
    } else {
        return '规模性'
    }
}

const taskStatusField = (status) => {
    switch (status) {
    case 1:
        return '成功'
    case -1:
        return '失败'
    case 0:
        return '进行中'
    default:
        return '进行中'
    }
}

const tradeDirectionField = (direction) => {
    switch (direction) {
    case 'SALE':
        return '卖出'
    case 'BUY':
        return '买入'
    default:
        return '--'
    }
}
const labelCondition = (con) => {
    con = parseInt(con)
    switch (con) {
    case 0:
        return '介于'

    case 1:
        return '大于'

    case 2:
        return '大于等于'

    case 3:
        return '小于'

    case 4:
        return '小于等于'

    case 5:
        return '等于'

    case 6:
        return '不等于'
    }
}

const conditionIndexField = (field) => {
    switch (field) {
    case 'annual_yield':
        return '年化收益率'

    case 'exceed_annual_yield':
        return '超额年化收益率'

    case 'max_drawdown':
        return '最大回撤'

    case 'sharpe_ratio':
        return '夏普比率'
    }
}

const taskStatusClassField = (status) => {
    switch (status) {
    case 1:
        return 'green'
    case 0:
        return ''
    case -1:
        return 'red'
    }
}

const multiStatusField = (status) => {
    let allNormal = 1
    for (let i of status) {
        i = Number(i)
        if (i === -1) {
            return 'warning-status'
        }
        if (i !== 1) {
            allNormal = 0
        }
    }
    if (allNormal === 1) {
        return 'ok-status'
    }
    return ''
}

const userRole = (role) => [ '超级管理员', '管理员', '策略员' ][role]

export {
    levelType,
    safeNumber,
    safeIntegerNumber,
    safeFloatFixedOne,
    safeFloatFixedTwo,
    safeFloatPerFixedTwo,
    safePercentFixedTwo,
    riseAndFallClass,
    eventNumberFixed,
    eventFallClass,
    changeDateVal,
    slicetwo,
    strategyType,
    strategyStatusClass,
    strategyStatus,
    strategyStatusExt,
    labelField,
    tradeDirectionField,
    taskStatusField,
    labelCondition,
    conditionIndexField,
    taskStatusClassField,
    multiStatusField,
    userRole
}



// WEBPACK FOOTER //
// ./src/filters/index.js